<template>
    <div class="d-flex flex-column of-y-f" style="position: relative">
        <v-app-bar
                dense
                color="primary"
                class="flex-grow-0"
        >
            <img alt="logo" src="../../../public/images/logo_light.svg" width="36px"/>
            <div class="pl-3 white--text">
                SALOM <span class="font-weight-medium">SCAN</span>
            </div>
            <div class="flex-grow-1 pl-3">
                <v-tabs
                        v-model="currentPage"
                        background-color="transparent"
                        color="secondary"
                        grow
                        dark
                        v-if="!loading"
                >
                    <v-tab>Dashboard</v-tab>
                    <v-tab v-show="user.adminOptions.users || user.adminOptions.setup">Setup</v-tab>
                    <v-tab v-if="user.adminOptions.recruitment">Recruitment</v-tab>
<!--                    <v-tab>Manual Data Import</v-tab>-->
<!--                    <v-tab>Reports</v-tab>-->
                </v-tabs>
            </div>
        </v-app-bar>

        <div class="of-y flex-grow-1">
            <div class="d-flex flex-column justify-center align-center fill-height" v-if="loading">
                <loader :size="60"/>
            </div>
            <div v-else class="fill-height of-y">
                <v-tabs-items fill-height v-model="currentPage" class="of-y fill-height grey lighten-3">

<!--Dashboard-->
                    <v-tab-item :value="0" class="fill-height of-y">
                        <v-card flat v-show="currentPage === 0" class="fill-height of-y">
                            <dashboard-view class="of-y"/>
                        </v-card>
                    </v-tab-item>
<!--Setup-->
                    <v-tab-item :value="1" v-if="user.adminOptions.users || user.adminOptions.setup" class="fill-height">
                        <setup/>
                    </v-tab-item>
<!--HR-->
                    <v-tab-item :value="2" class="fill-height">
                        <recruitment-groups-view/>
                    </v-tab-item>
<!--&lt;!&ndash;Manual Data Import&ndash;&gt;-->
<!--                    <v-tab-item :value="2">-->
<!--                        <v-card flat>-->
<!--                            <v-card-text>Manual Data Import</v-card-text>-->
<!--                        </v-card>-->
<!--                    </v-tab-item>-->
<!--&lt;!&ndash;Reports&ndash;&gt;-->
<!--                    <v-tab-item :value="3">-->
<!--                        <v-card flat>-->
<!--                            <v-card-text>Reports</v-card-text>-->
<!--                        </v-card>-->
<!--                    </v-tab-item>-->
                </v-tabs-items>

            </div>

        </div>
        <sync-notifications/>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Loader from "../General/Loader/Loader";
import Setup from "../Setup/Setup";
import DashboardView from "../Reports/DashboardView";
import SyncNotifications from "../SyncNotifications/SyncNotifications";
import RecruitmentGroupsView from "../Recruitment/RecruitmentGroupsView";

export default {
    components: {RecruitmentGroupsView, SyncNotifications, DashboardView, Setup, Loader},
    props: {
        test: Object
    },
    data() {
        return {
            loading: true,
            currentPage: 0
        }
    },
    mounted() {
        this.startup();
    },
    watch: {},
    methods: {
        ...mapActions(['upsert']),
        startup() {
            this.loading = true;
            this.$newReq('GET', 'main/startup')
                .then((data) => {
                    this.upsert(data)
                })
            .catch(e => {
                console.log(e)
                this.$snack.netWorkError()
            })
            .finally(() => {
                this.loading = false;
            })
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
}
</script>

<style scoped>

</style>